export default function Maillage() {
  const liens = [
    {
      href: "/reparation-volet-roulant",
      title: "Réparation de volet roulant",
      desc: "Toutes les pannes de volets roulants : sangle, moteur, tablier, télécommande. Diagnostic et intervention rapide.",
    },
    {
      href: "/depannage-urgence",
      title: "Dépannage urgence",
      desc: "Volet bloqué ou coincé en urgence ? Intervention rapide 24h/24 à Strasbourg et dans le Bas-Rhin.",
    },
    {
      href: "/moteur-somfy",
      title: "Moteur Somfy en panne",
      desc: "Remplacement de moteur Somfy en panne : déblocage, motorisation, réparation électrique.",
    },
  ];

  return (
    <section className="bg-white py-14 md:py-20">
      <div className="max-w-4xl mx-auto px-4 md:px-8">
        <h2 className="text-2xl md:text-3xl font-bold text-brand-blue text-center mb-3">
          Vous cherchez une autre prestation ?
        </h2>
        <p className="text-brand-text text-base text-center mb-10 md:mb-14 max-w-2xl mx-auto">
          Nous intervenons aussi sur ces services. Découvrez nos autres solutions pour votre volet roulant.
        </p>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-5">
          {liens.map((lien, i) => (
            <a
              key={i}
              href={lien.href}
              className="group bg-brand-light rounded-xl border border-brand-border p-5 hover:border-brand-cyan transition-colors"
            >
              <h3 className="font-semibold text-brand-blue mb-2 group-hover:text-brand-cyan transition-colors text-sm md:text-base">
                {lien.title}
              </h3>
              <p className="text-sm text-brand-text leading-relaxed">{lien.desc}</p>
              <span className="inline-flex items-center gap-1 text-brand-cyan text-sm font-medium mt-3">
                En savoir plus <i className="ri-arrow-right-line"></i>
              </span>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}